import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'
import { WorkScheduleOverlapPeriodFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import TableRowFixedSchedule from './RowFixedSchedule'
import TableRowFlexibleSchedule from './RowFlexibleSchedule'
import type { DayConfigurationWithBreaks } from './types'

interface Props {
  periods: WorkScheduleOverlapPeriodFragment[]
}

const TableBody = ({ periods }: Props) => {
  const dayConfPerPeriod = (
    period: WorkScheduleOverlapPeriodFragment
  ): DayConfigurationWithBreaks[] => {
    return period.dayConfigurations.map((dayConfiguration) => {
      return {
        dayConfiguration,
        breaks: dayConfiguration.plannedBreaks,
      }
    })
  }

  return (
    <Table.Body>
      {periods.map((period) =>
        period.scheduleType === 'fixed' ? (
          <TableRowFixedSchedule
            period={period}
            key={period.id}
            dayConfigsPerPeriod={dayConfPerPeriod(period)}
          />
        ) : (
          <TableRowFlexibleSchedule
            period={period}
            key={period.id}
            dayConfigsPerPeriod={dayConfPerPeriod(period)}
          />
        )
      )}
    </Table.Body>
  )
}

export default observer(TableBody)
